module.exports = __webpack_public_path__ + "2f79219fb19edd31931504e867bf87c7.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/minus_decrement_disabled.svg
// module id = 6S93
// module chunks = 5